import { C } from "./theme";

// A switch between two to five views ("Importance | Urgency", "List | Calendar"). `options` is
// [[value, label], …]; each is a 44px button with aria-pressed. The chosen one is outlined: in dark
// its fill is darker than the track, so fill alone doesn't show it. With five, a long label takes the room it
// needs from a short one ("Top"), so no word is cut.
export function Segmented({ label, options, value, onChange, stretch = false }) {
  return (
    <div role="group" aria-label={label}
      style={{ display: stretch ? "grid" : "inline-flex", gridTemplateColumns: stretch ? `repeat(${options.length}, ${options.length > 4 ? "minmax(min-content, 1fr)" : "minmax(0, 1fr)"})` : undefined, background: C.surface2, borderRadius: 10, padding: 2 }}>
      {options.map(([v, text]) => (
        <button key={v} onClick={() => onChange(v)} aria-pressed={value === v}
          style={{ minHeight: 44, padding: stretch ? (options.length > 4 ? "0 4px" : options.length > 3 ? "0 2px" : "0 6px") : "0 12px", borderRadius: 8, border: "none", cursor: "pointer", fontFamily: "inherit", fontSize: !stretch ? 13 : options.length < 4 ? 14 : options.length > 4 ? 12 : 13, fontWeight: 600, background: value === v ? C.surface : "transparent", color: value === v ? C.text : C.textMid, boxShadow: value === v ? `inset 0 0 0 1px ${C.borderCard}, ${C.shadow}` : "none" }}>
          {text}
        </button>
      ))}
    </div>
  );
}
